// FEATURE_025 (PRO Distribution Management) — PRD 06 v1.21 §2.2 No.5-1 / §3.7: under the disease filter card,
// name each layer ABOVE the selected row that still holds an undeployed change. A move between layers and a
// schedule change on a shared module both need several deploys, and without this notice an administrator who
// deployed one layer reads the job as finished.
//
// The server decides which layers qualify (`deploy.undeployedUpperLayers`), with the same status each layer's
// own row shows, so the notice and that row's chip cannot disagree.

import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';

import type { UpperLayer } from '../types/pro-deployment.types';

interface UpperLayerNoticeProps {
  layers: UpperLayer[] | undefined;
}

export function UpperLayerNotice({ layers }: UpperLayerNoticeProps) {
  const { t } = useTranslation('pro-deployment');
  if (!layers || layers.length === 0) return null;

  return (
    <div
      role="status"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        marginBottom: 'var(--space-6)',
        padding: 'var(--space-3) var(--space-4)',
        borderRadius: 'var(--radius-sm)',
        background: 'var(--badge-warning-bg)',
        color: 'var(--badge-warning-text)',
        fontSize: 'var(--font-size-sm)',
      }}
    >
      {layers.map((layer) => (
        <span
          key={`${layer.layer}-${layer.groupName ?? ''}`}
          style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}
        >
          <AlertTriangle size={14} aria-hidden />
          {layer.layer === 'GROUP'
            ? t('scope.upperLayer.group', { group: layer.groupName ?? '' })
            : t('scope.upperLayer.common')}
        </span>
      ))}
    </div>
  );
}
